export default __webpack_public_path__ + "static/media/FAQ_9_3.16d9134e.png";